import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClientService } from '../../../shared/services/http-client/http-client.service';
import {
  CreateInstitutoParamCommandDto,
  InstitutoParamResponseDto,
  InstitutosParamQueryParams,
  PatchInstitutoParamCommandDto,
  TipoInstitutoResponseDto,
  TiposInstitutoQueryParams,
} from '../../models/parametros/instituto-param-api.model';

const INSTITUTOS_PARAM_BASE_PATH = '/v1/institutos-param';
const TIPOS_INSTITUTO_BASE_PATH = '/v1/tipos-instituto';

@Injectable({
  providedIn: 'root',
})
export class InstitutosParamApiService {
  constructor(private readonly httpClient: HttpClientService) {}

  listarInstitutosParam(params?: InstitutosParamQueryParams): Observable<InstitutoParamResponseDto[]> {
    return this.httpClient.get<InstitutoParamResponseDto[]>(INSTITUTOS_PARAM_BASE_PATH, {
      params: this.toHttpParams(params),
    });
  }

  criarInstitutoParam(command: CreateInstitutoParamCommandDto): Observable<InstitutoParamResponseDto> {
    return this.httpClient.post<InstitutoParamResponseDto>(INSTITUTOS_PARAM_BASE_PATH, command);
  }

  atualizarInstitutoParam(id: number, command: PatchInstitutoParamCommandDto): Observable<InstitutoParamResponseDto> {
    return this.httpClient.patch<InstitutoParamResponseDto>(`${INSTITUTOS_PARAM_BASE_PATH}/${id}`, command);
  }

  listarTiposInstituto(params?: TiposInstitutoQueryParams): Observable<TipoInstitutoResponseDto[]> {
    return this.httpClient.get<TipoInstitutoResponseDto[]>(TIPOS_INSTITUTO_BASE_PATH, {
      params: this.toHttpParams(params),
    });
  }

  private toHttpParams(params?: InstitutosParamQueryParams | TiposInstitutoQueryParams): HttpParams | undefined {
    if (!params) {
      return undefined;
    }

    let httpParams = new HttpParams();

    for (const [chave, valor] of Object.entries(params)) {
      if (valor != null && valor !== '') {
        httpParams = httpParams.set(chave, String(valor));
      }
    }

    return httpParams.keys().length > 0 ? httpParams : undefined;
  }
}
